export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: false,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"en"},
  vueI18nLoader: true,
  locales: [{"code":"en","name":"English","dir":"ltr"},{"code":"fr","name":"French","dir":"ltr"},{"code":"it","name":"Italian","dir":"ltr"},{"code":"de","name":"German","dir":"ltr"},{"code":"es","name":"Spanish","dir":"ltr"},{"code":"pt","name":"Portuguese","dir":"ltr"},{"code":"jp","name":"Japanese","dir":"ltr"},{"code":"ko","name":"Korean","dir":"ltr"},{"code":"zh_TW","name":"Chinese Traditional","dir":"ltr"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_and_default",
  lazy: false,
  langDir: null,
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","onlyOnNoPrefix":false,"onlyOnRoot":false,"useCookie":true},
  differentDomains: false,
  seo: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncLocale":true,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"en","name":"English","dir":"ltr"},{"code":"fr","name":"French","dir":"ltr"},{"code":"it","name":"Italian","dir":"ltr"},{"code":"de","name":"German","dir":"ltr"},{"code":"es","name":"Spanish","dir":"ltr"},{"code":"pt","name":"Portuguese","dir":"ltr"},{"code":"jp","name":"Japanese","dir":"ltr"},{"code":"ko","name":"Korean","dir":"ltr"},{"code":"zh_TW","name":"Chinese Traditional","dir":"ltr"}],
  localeCodes: ["en","fr","it","de","es","pt","jp","ko","zh_TW"],
}

export const localeMessages = {}
